<template>
  <div>
    <Modal v-model="modal" :title="!redshiftWarningForm.id ? this.$t('alarms.redshift.addRedshiftAlarm') : this.$t('alarms.redshift.editRedshiftAlarm')" @on-cancel="cancel" @on-ok="ok" :loading="loading" :mask-closable="false" :styles="{top:'65px'}" width="800px" :footer-hide="true" :closable="false">
      <Form ref="redshiftWarningForm" :model="redshiftWarningForm" :label-width="110"
            :rules="ruleValidate">
        <!-- 下一步 -->
        <div v-show="isNext">
          <!-- 微信警告 -->
          <wechat-warning v-if="wechatWarningVisible" ref="wechatWarning"></wechat-warning>
          <!-- 规则名称 -->
          <FormItem :label="$t('alarms.common.ruleName')" prop="ruleName" v-if="isEditRuleName">
            <Row>
              <Col span="11">
                <Input type="text" v-model="redshiftWarningForm.ruleName" placeholder="Enter something..."
                       style="width:300px;" :disabled="isEdit"></Input>
              </Col>
            </Row>
          </FormItem>

          <!-- 规则名称 -->
          <FormItem :label="$t('alarms.common.ruleName')" v-if="showRuleName">
            <Row>
              <Col span="24">
                <div>{{this.redshiftWarningForm.ruleName}}</div>
              </Col>
            </Row>
          </FormItem>

          <!-- 规则描述 -->
          <FormItem :label="$t('alarms.common.ruleDescription')">
            <Row :gutter="4">
              <!-- 监控指标 -->
              <Col span="4">
                <FormItem prop="monitorIndex">
                  <Select v-model="redshiftWarningForm.monitorIndex"
                          filterable
                          @on-change="changeMonitorIndex(redshiftWarningForm.monitorIndex)"
                          :placeholder="$t('alarms.common.pleaseSelect')">
                    <Option :value="item.id" v-for="item in monitorIndexList" :key="item.id">{{item.name}}</Option>
                  </Select>
                </FormItem>
              </Col>
              <!-- 周期 -->
              <Col span="3">
                <FormItem prop="cycle">
                  <Select v-model="redshiftWarningForm.cycle" filterable :placeholder="$t('alarms.common.cycle')"
                          @on-change="changeCycle(redshiftWarningForm.cycle)">
                    <Option :value="item.id" v-for="(item,index) in cycleList" v-bind:key="index">{{item.name}}</Option>
                  </Select>
                </FormItem>
              </Col>
              <!-- 连续周期 -->
              <Col span="4">
                <FormItem prop="continousCycle">
                  <Select v-model="redshiftWarningForm.continousCycle" filterable :placeholder="$t('alarms.common.continuousCycle')"
                          @on-change="changeContinousCycle(redshiftWarningForm.continousCycle)">
                    <Option :value="item.id" v-for="(item,index) in continousCycleList" v-bind:key="index">{{item.name}}</Option>
                  </Select>
                </FormItem>
              </Col>
              <!-- 统计数值 -->
              <Col span="4">
                <FormItem prop="statisticsValue">
                  <Select v-model="redshiftWarningForm.statisticsValue" filterable :placeholder="$t('alarms.common.statisticsValue')"
                          @on-change="changeStatisticsValue(redshiftWarningForm.statisticsValue)">
                    <Option :value="item.id" v-for="(item,index) in statisticsValueList" v-bind:key="index">{{item.name}}</Option>
                  </Select>
                </FormItem>
              </Col>

                <!-- 关系符号 -->
                <Col span="3">
                  <FormItem prop="relationshipSign">
                    <Select v-model="redshiftWarningForm.relationshipSign"
                            filterable
                            @on-change="changeRelationshipSign(redshiftWarningForm.relationshipSign)"
                            :placeholder="$t('alarms.common.symbol')">
                      <Option :value="item.id" v-for="(item,index) in relationshipSignList" v-bind:key="index">{{item.name}}</Option>
                    </Select>
                  </FormItem>
                </Col>
                <!-- 阈值 -->
                <Col span="3">
                  <FormItem prop="thresholdValue">
                    <Input v-model="redshiftWarningForm.thresholdValue" :placeholder="$t('alarms.common.threshold')" type="number"></Input>
                  </FormItem>
                </Col>
                <!-- 单位 -->
                <Col span="2">
                  <FormItem prop="unit">
                    <Input v-model="redshiftWarningForm.unit" disabled :placeholder="$t('alarms.common.unit')"></Input>
                  </FormItem>
                </Col>
            </Row>
          </FormItem>

          <!-- 联系方式 -->
          <FormItem :label="$t('alarms.common.contactType')" prop="contactType">
              <RadioGroup v-model="redshiftWarningForm.contactType" @on-change="changeContactType(redshiftWarningForm.contactType)">
                  <Radio v-for="item in contactTypeList" :label="item.type" :key="item.value">{{item.label}}</Radio>
              </RadioGroup>
          </FormItem>

          <!-- 通知对象 -->
          <FormItem :label="$t('alarms.common.notificationObject')" prop="notificationObject" v-if="redshiftWarningForm.contactType==0">
            <Select v-model="redshiftWarningForm.notificationObject" filterable multiple style="width:300px;" @on-change="changeNotificationObject" :placeholder="$t('alarms.common.pleaseSelect')">
              <Option v-for="item in notificationObjectList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>

          <!-- 联系人组 -->
          <FormItem :label="$t('alarms.common.contactGroup')" prop="contactGroupIds" v-if="redshiftWarningForm.contactType==1">
            <Select v-model="redshiftWarningForm.contactGroupId" filterable multiple style="width:300px;" @on-change="changeContactGroupId(redshiftWarningForm.contactGroupIds)" :placeholder="$t('alarms.common.pleaseSelect')">
              <Option v-for="item in contactGroupIdList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>

          <!-- 报警方式 -->
          <FormItem :label="$t('alarms.common.noticeType')" prop="noticeType">
            <Select v-model="redshiftWarningForm.noticeType" filterable multiple style="width:300px;" @on-change="selectnoticeType(redshiftWarningForm.noticeType)" :placeholder="$t('alarms.common.pleaseSelect')">
              <Option v-for="item in alarmWayList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>

          <!-- 企业微信机器人URL -->
          <FormItem :label="$t('alarms.common.enterpriseWeChatRobotURL')" prop="enterpriseWechatRobotIds" v-if="redshiftWarningForm.noticeType.filter(function (e) { return e == 3; }).length != 0">
            <Select v-model="redshiftWarningForm.enterpriseWechatRobotIds" filterable multiple style="width:300px;" :placeholder="$t('alarms.common.pleaseSelect')">
              <Option v-for="item in enterpriseWechatRobotIdsList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>

          <!-- 延迟告警 -->
          <FormItem :label="$t('alarms.common.alarmDelay')" prop="alarmDelay">
            <Select v-model="redshiftWarningForm.alarmDelay" filterable style="width:300px;" :placeholder="$t('alarms.common.pleaseSelect')">
              <Option v-for="item in alarmDelayList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>

          <!-- 监控时段 -->
          <FormItem :label="$t('alarms.common.monitorPeriod')" prop="monitorPeriod">
            <Select v-model="redshiftWarningForm.monitorPeriod" filterable style="width:300px;" :placeholder="$t('alarms.common.pleaseSelect')">
              <Option v-for="item in monitorPeriodList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>

          <!-- 邮箱模板 -->
          <div v-show="isShowEmail">
            <FormItem :label="$t('alarms.common.emailModal')" prop="emailModal">
              <Input v-model="redshiftWarningForm.emailModal" type="textarea"
                     :autosize="{minRows: 2,maxRows: 5}" style="width:665px;" disabled></Input>
            </FormItem>
          </div>

          <!-- 企业微信模板 -->
          <div v-show="isShowWeChat">
            <FormItem :label="$t('alarms.common.wechatModal')" prop="wechatModal">
              <Input v-model="redshiftWarningForm.wechatModal" type="textarea"
                     :autosize="{minRows: 2,maxRows: 5}" style="width:665px;" disabled></Input>
            </FormItem>
          </div>
          <div style="height: 42px;">
            <Button type="primary" size="large" style="float: right;" @click="ok('redshiftWarningForm')" :loading="addloading"  :disabled="isAddOrEdit">
              {{!redshiftWarningForm.id ? this.$t('common.addAlarm'):this.$t('common.editAlarm')}}
            </Button>
            <Button size="large" style="float: right;margin-right: 10px;"
                    @click="cancel('redshiftWarningForm')">{{ $t('alarms.common.cancel') }}
            </Button>
            <Button size="large" @click="previousPage" style="float: right;margin-right: 10px;">{{ $t('alarms.common.lastStep') }}</Button>
          </div>
        </div>

        <!-- 上一步 -->
        <div v-show="isPrevious">
          <div>
            <Row :gutter="16">
              <Col span="8">
                <!-- 账户 -->
                <FormItem :label="$t('alarms.common.account')" prop="account" :label-width="70">
                  <Select v-model="redshiftWarningForm.account" filterable @on-change="changeAccount(redshiftWarningForm.account)" :transfer="true" :placeholder="$t('alarms.common.pleaseSelect')">
                    <Option :value="item.id" v-for="(item,index) in accountList" v-bind:key="index">{{item.name}}</Option>
                  </Select>
                </FormItem>
              </Col>
              <Col span="10" style="z-index: 200">
                <!-- 存储区域 -->
                <FormItem :label="$t('alarms.common.region')" prop="backupRegion">
                  <Select @on-change="changebackupRegion(redshiftWarningForm.backupRegion)" v-model="redshiftWarningForm.backupRegion" filterable multiple :max-tag-count="1" :transfer="true" :placeholder="$t('alarms.common.pleaseSelect')">
                    <Checkbox v-model="singleBackupRegion" @on-change="selectBackupRegionAll" style="display: block;text-align:right;">{{ $t('alarms.common.all') }}</Checkbox>
                    <Option :value="item.name" v-for="item in backupRegionList" :key="item.id">{{item.name}}</Option>
                  </Select>
                </FormItem>
              </Col>
              <Button type="primary" style="float:right;" v-show="isShowSearch" @click="searchRedshiftDate">{{ $t('alarms.common.search') }}</Button>
            </Row>
          </div>

          <v-table :height="459" column-width-drag is-horizontal-resize
                   style="width:100%;height:459px;margin-bottom: 15px;" :columns="column" :table-data="tableRedshiftDate"
                   row-hover-color="#edf7ff" :is-loading="modal_loadings" title-bg-color="#f8f8f9"
                   :select-group-change="selectChange" :select-all="selectAll"></v-table>
          <div style="height: 42px;">
            <Button type="primary" size="large" @click="nextPage" style="float: right;" :disabled="isNextClick">{{ $t('alarms.common.nextStep') }}
            </Button>
            <Button size="large" style="margin-right: 10px;float: right;"
                    @click="cancel('redshiftWarningForm')">{{ $t('alarms.common.cancel') }}
            </Button>
          </div>
        </div>
      </Form>
    </Modal>
  </div>
</template>
<script>
    import WechatWarning from '../common/WechatWarning.vue'
    import {setCookie, getCookie} from '../../../utils/cookieUtil.js'
    import TableRedshift from '../redshift/TableRedshift.vue'

    var tableRedshift = TableRedshift;
    var tableRedshiftWarningVue = {}
    export default {
        inject: ['reload'],
        components: {
            WechatWarning
        },
        data() {
            // 名字是否重复
            var validNameRepeatedCheck = (rule, value, callback) => {
                var self = this;
                self.$api.alertRule.nameRepeatedCheck({
                    "alertRuleName": this.redshiftWarningForm.ruleName,
                    "monitorModule": this.monitorModule
                })
                .then(res => {
                    if (res.status == 200) {
                        callback();
                    }
                })
                .catch(err => {
                    if (err.status == 400) {
                        callback(new Error(this.$t('monitor.alarmRule.ruleNameRepeated')));
                    }
                })
            };
            return {
                monitorModule:3,
                isAddOrEdit:true,
                wechatWarningVisible: false,
                contactTypeList: [{
                    label: this.$t('alarms.common.contactPerson'),
                    value: 'contact',
                    type: 0
                },
                    {
                        label: this.$t('alarms.common.contactGroup'),
                        value: 'contactGroup',
                        type: 1
                    }],
                addloading:false,
                singleBackupRegion:false,
                alarmDelayList:[],
                monitorPeriodList:[],
                isEdit: false,
                isShowSearch: false,
                isEditRuleName: false,
                showRuleName: false,
                modal_loadings: false,
                isShowEmail: false,
                isShowWeChat: false,
                isNext: false,
                isPrevious: true,
                selection: [],
                accountList: [],
                notificationObjectList: [],
                alarmWayList: [],
                backupRegionList: [],
                loading: true,
                modal: false,
                modal_loading: false,
                exportDataList: '',
                noticeType: [],
                units: '',
                isNextClick: true, //禁止点击下一步
                unit: '',
                redshiftWarningForm: {
                    account: '',
                    ruleName: '',
                    notificationObject: [],
                    noticeType: [],
                    emailModal: '',
                    wechatModal: '',
                    thresholdValue: '',
                    monitorIndex: '',
                    cycle: '',
                    continousCycle: '',
                    statisticsValue: '',
                    relationshipSign: '',
                    unit: '',
                    backupRegion: [],
                    alarmDelay:'',
                    monitorPeriod:'',
                    contactType:0,
                    contactGroupIds:[],
                    userIdList:[],
                    enterpriseWechatRobotIds:[]
                },
                enterpriseWechatRobotIdsList:[],
                // 联系人组
                contactGroupIdList:[],
                // 监控指标
                monitorIndexList: [],
                // 周期
                cycleList: [],
                // 连续周期
                continousCycleList: [],
                // 统计数值
                statisticsValueList: [],
                // 关系符号
                relationshipSignList: [],
                ruleValidate: {
                    account: [
                        {required: true, message: this.$t('monitor.alarmRule.accountRequired'), trigger: 'change', type: 'number'}
                    ],
                    alarmDelay: [
                        {required: true, message: this.$t('monitor.alarmRule.alarmDelayRequired'), trigger: 'change', type: 'number'}
                    ],
                  monitorPeriod: [
                    {required: true, message: this.$t('monitor.alarmRule.monitorPeriodRequired'), trigger: 'change', type: 'number'}
                  ],
                    backupRegion: [
                        {required: true, type: 'array', message: this.$t('monitor.alarmRule.regionRequired'), trigger: 'change'}
                    ],
                    ruleName: [
                        {required: true, message: this.$t('monitor.alarmRule.ruleNameRequired'), trigger: 'blur'},
                        {type: 'string', message: this.$t('monitor.alarmRule.ruleNamePattern'), pattern: '^[^ ]{2,20}$', trigger: 'blur'},
                        {validator: validNameRepeatedCheck, trigger: 'blur'}
                    ],
                    notificationObject: [
                        {required: true, type: 'array', message: this.$t('monitor.alarmRule.notificationObjectRequired'), trigger: 'change'}
                    ],
                    noticeType: [
                        {required: true, type: 'array', min: 1, message: this.$t('monitor.alarmRule.noticeTypeRequired'), trigger: 'change'}
                    ],
                    monitorIndex: [
                        {required: true, message: this.$t('monitor.alarmRule.monitorIndexRequired'), trigger: 'change', type: 'number'}
                    ],
                    cycle: [
                        {required: true, message: this.$t('monitor.alarmRule.cycleRequired'), trigger: 'change', type: 'number'}
                    ],
                    continousCycle: [
                        {required: true, message: this.$t('monitor.alarmRule.continousCycleRequired'), trigger: 'change', type: 'number'}
                    ],
                    statisticsValue: [
                        {required: true, message: this.$t('monitor.alarmRule.statisticsValueRequired'), trigger: 'change', type: 'number'}
                    ],
                    relationshipSign: [
                        {required: true, message: this.$t('monitor.alarmRule.relationshipSignRequired'), trigger: 'change', type: 'number'}
                    ],
                    thresholdValue: [
                        {required: true, message: this.$t('monitor.alarmRule.thresholdRequired')}
                    ],
                    contactType: [
                        {required: true, message: this.$t('monitor.alarmRule.contactTypeRequired'), trigger: 'change', type: 'number'}
                    ],
                    contactGroupIds: [
                        {required: true, message: this.$t('monitor.alarmRule.contactGroupRequired'), trigger: 'change', type: 'array'}
                    ],
                    enterpriseWechatRobotIds: [
                        {required: true, type: 'array', message: this.$t('monitor.alarmRule.enterpriseWechatRobotRequired'), trigger: 'change'}
                    ]
                },
                column: [
                    {
                        width: 60,
                        titleAlign: 'center',
                        columnAlign: 'center',
                        type: 'selection'
                    },
                    {
                        field: 'accountName',
                        title: this.$t('alarms.redshift.accountName'),
                        width: 80,
                        titleAlign: 'center',
                        columnAlign: 'center',
                        isResize: true
                    },
                    {
                        field: 'clusterIdentifier',
                        title: this.$t('alarms.redshift.cluster'),
                        width: 80,
                        titleAlign: 'center',
                        columnAlign: 'center',
                        isResize: true
                    },
                    {
                        field: 'nodeType',
                        title: this.$t('alarms.redshift.nodeType'),
                        width: 80,
                        titleAlign: 'center',
                        columnAlign: 'center',
                        isResize: true
                    },
                    {
                        field: 'nodes',
                        title: this.$t('alarms.redshift.nodeSize'),
                        width: 80,
                        titleAlign: 'center',
                        columnAlign: 'center',
                        isResize: true
                    }
                ],
                tableRedshiftDate: [],
                newTableRedshiftDateList: [],
                instanceList: [],
                compareRedshiftList:[]
            }
        },

        beforeCreate: function () {
            tableRedshiftWarningVue = this
        },
        methods: {
            //显示表格数据
            /****************************************************************/
            // 下一步
            nextPage: function () {
                this.isNext = true;
                this.isPrevious = false;
                // 查询监控指标
                tableRedshiftWarningVue.searchMonitorIndex();
                // 查询阈值
                tableRedshiftWarningVue.selectMonitorIndexDefault();
                // 监控模块查询关联的机器人列表
                tableRedshiftWarningVue.listEnterpriseWechatRobotsByMonitorModule();
                // 查询联系人组
                tableRedshiftWarningVue.listContactGroups();
            },
            // 上一步
            previousPage: function () {
                this.isNext = false;
                this.isPrevious = true;
            },
            init: function (id) {
                this.redshiftWarningForm.id = id || 0;
                // 根据用户名查询Account列表
                tableRedshiftWarningVue.getAccount();
                this.$nextTick(() => {
                    // 重置表单
                    this.$refs['redshiftWarningForm'].resetFields();
                    // 编辑
                    if (this.redshiftWarningForm.id) {
                        // 编辑显示不能输入的规则名称
                        this.showRuleName = true;
                        this.isEdit = true;
                        this.isShowSearch = false;
                        this.$api.alertRule.selectAlertRule("id", this.redshiftWarningForm.id)
                            .then(res => {
                                //延时
                                this.redshiftWarningForm.alarmDelay = res.data.delay;
                                //监控时段
                                this.redshiftWarningForm.monitorPeriod = res.data.monitorPeriod;
                                // 账户
                                /******************************************************/
                                this.redshiftWarningForm.account = res.data.accountId;
                                tableRedshiftWarningVue.$api.account.queryAccountRegions("accountId", this.redshiftWarningForm.account)
                                .then(res => {
                                    this.backupRegionList = res.data;
                                });

                              //查询联系人
                              tableRedshiftWarningVue.$api.contact.queryContactsByAccountIdAndMonitorModule({
                                "monitorModule":this.monitorModule,
                                "accountId":this.redshiftWarningForm.account
                              })
                                .then(res => {
                                  this.notificationObjectList = res.data.contactList;
                                });

                                this.modal_loadings = true;

                                setTimeout(() => {
                                    // 存储区域
                                    this.redshiftWarningForm.backupRegion = res.data.regions;

                                    // 实例列表
                                    /******************************************************/
                                    this.instanceList = res.data.resourceClusterDTOList;

                                    this.compareRedshiftList=res.data.resourceClusterDTOList;
                                    // 根据AccountId查询Instance列表
                                    tableRedshiftWarningVue.$api.redshift.queryRedshiftByAccount({
                                        "regions": this.redshiftWarningForm.backupRegion,
                                        "accountId": this.redshiftWarningForm.account
                                    })
                                    .then(res => {
                                        this.tableRedshiftDate = res.data;
                                        this.modal_loadings = false;
                                        for (var i = 0; i < this.tableRedshiftDate.length; i++) {
                                            for (var j = 0; j < this.compareRedshiftList.length; j++) {
                                                if (this.tableRedshiftDate[i].id == this.compareRedshiftList[j].id) {
                                                    this.tableRedshiftDate[i]._checked = true;
                                                }
                                            }
                                        }
                                        // 选了数据 可以点击下一步
                                        if (this.tableRedshiftDate.length == 0 || this.compareRedshiftList.length == 0) {
                                            this.isNextClick = true;
                                        } else {
                                            this.isNextClick = false;
                                        }
                                    })
                                }, 1000)

                                this.newTableRedshiftDateList = res.data.resourceClusterDTOList;


                                // 规则名称
                                this.redshiftWarningForm.ruleName = res.data.alertRuleName;

                                // 监控指标
                                /******************************************************/
                                this.redshiftWarningForm.monitorIndex = res.data.monitorIndex;
                                // 周期
                                this.redshiftWarningForm.cycle = res.data.cycle;
                                // 连续周期
                                this.redshiftWarningForm.continousCycle = res.data.continousCycle;
                                // 统计数值
                                this.redshiftWarningForm.statisticsValue = res.data.statisticsValue;
                                // 符号
                                this.redshiftWarningForm.relationshipSign = res.data.relationshipSign;
                                // 阈值
                                this.redshiftWarningForm.thresholdValue = res.data.thresholdValue;
                                // 单位
                                this.redshiftWarningForm.unit = res.data.unit;
                                this.units = res.data.unitId;
                                // 企业微信机器人URL
                                this.redshiftWarningForm.enterpriseWechatRobotIds=res.data.enterpriseWechatRobotIds;

                                // 联系方式
                                this.redshiftWarningForm.contactType = res.data.contactType;
                                if(res.data.contactType==0){
                                    // 通知对象
                                    this.redshiftWarningForm.notificationObject = res.data.contactIDs;
                                    for(var i=0;i<this.redshiftWarningForm.notificationObject.length;i++){
                                      for(var j=0;j<this.notificationObjectList.length;j++){
                                        if(this.redshiftWarningForm.notificationObject[i]==this.notificationObjectList[j].id){
                                           this.redshiftWarningForm.userIdList.push(this.notificationObjectList[j].userId); //传值
                                        }
                                      }
                                    }
                                }else if(res.data.contactType==1){
                                    // 联系人组
                                    this.$api.contactGroup.listContactGroupsByAccountId("accountId", this.redshiftWarningForm.account)
                                    .then(res => {
                                        this.contactGroupIdList = res.data;
                                    })
                                    setTimeout(() => {
                                        this.redshiftWarningForm.contactGroupIds = res.data.contactGroupIds;
                                    }, 1000)
                                }

                                // 报警方式
                                this.redshiftWarningForm.noticeType = res.data.noticeType;

                                for (var i = 0; i < this.redshiftWarningForm.noticeType.length; i++){

                                  if (this.redshiftWarningForm.noticeType[i] == '0') {
                                    this.isShowEmail = true;
                                    this.redshiftWarningForm.emailModal = res.data.briefReportBodyMail;
                                    this.noticeType = this.redshiftWarningForm.noticeType;
                                    tableRedshiftWarningVue.selectTemplate();
                                  }
                                  if (this.redshiftWarningForm.noticeType[i] == '1') {
                                    // this.isShowWeChat = true;
                                    this.redshiftWarningForm.wechatModal = res.data.briefReportBodyWechat;
                                    this.checkLeastOnePersonBoundWeChat();
                                    this.noticeType = this.redshiftWarningForm.noticeType;
                                    tableRedshiftWarningVue.selectTemplate();
                                  }else if(this.redshiftWarningForm.noticeType[i]!='1'){
                                      this.wechatWarningVisible=false;
                                      this.isAddOrEdit=false;
                                  }

                                }
                            })
                    } else {
                        this.tableRedshiftDate = [];
                        this.isEdit = false;
                        this.isShowSearch = true;
                        // 添加显示规则名称能输入
                        this.isEditRuleName = true;
                        this.showRuleName = false;
                    }
                })
                this.modal = true;
                this.isNext = false;
                this.isPrevious = true;
            },
            // 根据监控指标 显示不同单位
            /****************************************************************/
            // 清空周期、连续周期、统计数值、关系符号
            emptyDate: function () {
                this.redshiftWarningForm.cycle = '';
                this.redshiftWarningForm.continousCycle = '';
                this.redshiftWarningForm.statisticsValue = '';
                this.redshiftWarningForm.relationshipSign = '';
                this.redshiftWarningForm.thresholdValue = '';
            },
            isNotEmpty: function (obj) {
                if (typeof obj === "undefined" || obj === null || obj === "") {
                    return false;
                } else {
                    return true;
                }
            },
            // 根据监控指标 显示不同单位
            changeMonitorIndex: function () {
                tableRedshiftWarningVue.selectMonitorIndexDefault();
                this.unit = this.redshiftWarningForm.monitorIndex;
                for (var i = 0; i < this.monitorIndexList.length; i++) {
                    if (this.monitorIndexList[i].id == this.unit) {
                        this.redshiftWarningForm.unit = this.monitorIndexList[i].unit;
                        this.units = this.monitorIndexList[i].id;
                    }
                }
                tableRedshiftWarningVue.selectTemplate();
                tableRedshiftWarningVue.emptyDate();
            },
            // 监控模块查询关联的机器人列表
            listEnterpriseWechatRobotsByMonitorModule:function(){
                tableRedshiftWarningVue.$api.enterpriseWechatRobot.listEnterpriseWechatRobotsByMonitorModule({
                      "monitorModule":this.monitorModule
                  })
                  .then(res => {
                      this.enterpriseWechatRobotIdsList = res.data;
                  })
            },
            // 查询阈值
            /****************************************************************/
            selectMonitorIndexDefault: function () {
                if (this.redshiftWarningForm.account == "" || this.redshiftWarningForm.account == null) {
                    return;
                }
                tableRedshiftWarningVue.$api.alertRule.selectMonitorIndexDefault({
                    "monitorIndex": this.redshiftWarningForm.monitorIndex,
                    "monitorModule": this.monitorModule,
                    "cycle": this.redshiftWarningForm.cycle,
                    "continousCycle": this.redshiftWarningForm.continousCycle,
                    "statisticsValue": this.redshiftWarningForm.statisticsValue,
                    "relationshipSign": this.redshiftWarningForm.relationshipSign,
                    "accountId": this.redshiftWarningForm.account
                })
                .then(res => {
                    // 周期
                    this.cycleList = res.data.cycleMap;
                    // 连续周期
                    this.continousCycleList = res.data.continousCycleMap;
                    // 统计数值
                    this.statisticsValueList = res.data.statisticsValueMap;
                    // 关系符号
                    this.relationshipSignList = res.data.relationshipSignMap;
                    // 阈值
                    if (res.data.companyMonitoritemVariablesList.length == 1 && tableRedshiftWarningVue.isNotEmpty(this.redshiftWarningForm.cycle) && tableRedshiftWarningVue.isNotEmpty(this.redshiftWarningForm.continousCycle) && tableRedshiftWarningVue.isNotEmpty(this.redshiftWarningForm.statisticsValue) && tableRedshiftWarningVue.isNotEmpty(this.redshiftWarningForm.relationshipSign) && this.redshiftWarningForm.id == 0) {
                        this.redshiftWarningForm.thresholdValue = res.data.companyMonitoritemVariablesList[0].customerMonitorIndexDefaultValue;
                    }

                })
            },
            // 查询邮件模板
            /****************************************************************/
            selectTemplate: function () {
                tableRedshiftWarningVue.$api.briefReport.selectTemplate({
                    "monitorIndex": this.redshiftWarningForm.monitorIndex,
                    "relationshipSign": this.redshiftWarningForm.relationshipSign,
                    "monitorModule": this.monitorModule,
                    "noticeType": this.redshiftWarningForm.noticeType
                })
                .then(res => {
                    this.redshiftWarningForm.wechatModal = res.data.briefReportBodyWechat;
                    this.redshiftWarningForm.emailModal = res.data.briefReportBodyMail;
                })
            },
            //报警方式为邮箱显示邮箱模板  为企业微信显示企业微信模板
            selectnoticeType: function () {
              this.isShowEmail = false;
              this.isShowWeChat = false;
              for(var i=0;i<this.redshiftWarningForm.noticeType.length;i++) {
                if (this.redshiftWarningForm.noticeType[i] == '0') {
                  this.isShowEmail = true;
                  this.noticeType = this.redshiftWarningForm.noticeType;
                  tableRedshiftWarningVue.selectTemplate();
                }
                if (this.redshiftWarningForm.noticeType[i] == '1') {
                  // this.isShowWeChat = true;
                  this.noticeType = this.redshiftWarningForm.noticeType;
                  this.checkLeastOnePersonBoundWeChat();
                  tableRedshiftWarningVue.selectTemplate();
                }else if(this.redshiftWarningForm.noticeType[i]!='1'){
                    this.wechatWarningVisible=false;
                    this.isAddOrEdit=false;
                }
              }
            },
            // 检查至少有一人绑定过微信
            checkLeastOnePersonBoundWeChat:function(){
              for(var i=0;i<this.redshiftWarningForm.noticeType.length;i++){
                  if(this.redshiftWarningForm.noticeType[i]==1){
                      var weChatDate={
                          "contactType":this.redshiftWarningForm.contactType
                      };
                      // 联系方式为 -联系人-
                      if(this.redshiftWarningForm.contactType==0){
                          weChatDate.userIds=this.redshiftWarningForm.userIdList;
                      }
                      // 联系方式为 -联系人组-
                      else if(this.redshiftWarningForm.contactType==1){
                          weChatDate.contactGroupIds = this.redshiftWarningForm.contactGroupIds;
                      }
                      this.$api.userWeChat.checkLeastOnePersonBoundWeChat(weChatDate)
                      .then(res => {
                          if(res.data){
                            // 可以添加告警
                            this.wechatWarningVisible=false;
                            this.isAddOrEdit=false;
                          }else{
                            // 不可以添加微信告警
                            this.wechatWarningVisible=true;
                            this.isAddOrEdit=true;
                          }
                      })
                  }else if(this.redshiftWarningForm.noticeType[i]!=1){
                      this.wechatWarningVisible=false;
                      this.isAddOrEdit=false;
                  }
              }
            },
            // 联系人组
            listContactGroups:function(){
                this.$api.contactGroup.listContactGroupsByAccountId("accountId", this.redshiftWarningForm.account)
                .then(res => {
                    this.contactGroupIdList = res.data;
                })
            },
            // 切换联系人组
            changeContactGroupId:function(){
               this.checkLeastOnePersonBoundWeChat();
            },
            // 切换通知对象
            changeNotificationObject:function(val){
              this.redshiftWarningForm.userIdList=[];
              this.redshiftWarningForm.notificationObject=val;
              for(var i=0;i<this.redshiftWarningForm.notificationObject.length;i++){
                for(var j=0;j<this.notificationObjectList.length;j++){
                  if(this.redshiftWarningForm.notificationObject[i]==this.notificationObjectList[j].id){
                     this.redshiftWarningForm.userIdList.push(this.notificationObjectList[j].userId); //传值
                  }
                }
              }
              this.checkLeastOnePersonBoundWeChat();
            },
            // 切换联系方式
            changeContactType:function(){
              this.checkLeastOnePersonBoundWeChat();
            },
            //点击查询 加载全部数据
            /***********************************************************************************/
            searchRedshiftDate: function () {
                if (this.redshiftWarningForm.account == "" || this.redshiftWarningForm.account == null || this.redshiftWarningForm.backupRegion == "" || this.redshiftWarningForm.backupRegion == null) {
                    return;
                }
                this.modal_loadings = true;
                // 根据AccountId查询Instance列表
                tableRedshiftWarningVue.$api.redshift.queryRedshiftByAccount({
                    "regions": this.redshiftWarningForm.backupRegion,
                    "accountId": this.redshiftWarningForm.account
                })
                .then(res => {
                    this.tableRedshiftDate = res.data;
                    this.modal_loadings = false;
                })
            },

            /**************************************  查询  **************************************/
            // 查询监控指标
            searchMonitorIndex: function () {
                tableRedshiftWarningVue.$api.alertRule.searchMonitorIndex({
                  "monitorModule":this.monitorModule,
                  "accountId":this.redshiftWarningForm.account
                })
                .then(res => {
                    this.monitorIndexList = res.data;
                })
            },
            // 查询通知对象
            queryContacts: function () {
              tableRedshiftWarningVue.$api.contact.queryContactsByAccountIdAndMonitorModule({
                "monitorModule":this.monitorModule,
                "accountId":this.redshiftWarningForm.account
              })
                .then(res => {
                    this.notificationObjectList = res.data.contactList;
                    this.redshiftWarningForm.notificationObject = res.data.defaultContactIds;
                })
            },
            // 查询报警方式
            alarmWay: function () {
                tableRedshiftWarningVue.$api.alertRule.alarmWay("userName",getCookie(global.cookieName))
                .then(res => {
                  this.alarmWayList = res.data;
              })
            },
             // 查询报警延迟
            getAlarmDelay: function () {
                tableRedshiftWarningVue.$api.alertRule.alarmDelay("userName",getCookie(global.cookieName))
                .then(res => {
                  this.alarmDelayList = res.data;
              })
            },
          // 查询监控时间段
          searchMonitorPeriod: function(){
            this.$api.alertRule.monitorPeriod("userName",getCookie(global.cookieName))
              .then(res => {
                this.monitorPeriodList = res.data;
              })
          },
            // 周期
            changeCycle: function () {
                // 查询阈值
                tableRedshiftWarningVue.selectMonitorIndexDefault();
            },
            // 连续周期
            changeContinousCycle: function () {
                // 查询阈值
                tableRedshiftWarningVue.selectMonitorIndexDefault();
            },
            // 统计数值
            changeStatisticsValue: function () {
                // 查询阈值
                tableRedshiftWarningVue.selectMonitorIndexDefault();
            },
            // 关系符号
            changeRelationshipSign: function () {
                // 查询阈值
                tableRedshiftWarningVue.selectMonitorIndexDefault();
                // 邮件模板
                tableRedshiftWarningVue.selectTemplate();
            },
            // 根据用户名查询Account列表
            getAccount: function () {
                // 清空表格
                this.tableRedshiftDate = [];
                tableRedshiftWarningVue.$api.account.queryAccounts("userName", getCookie(global.cookieName))
                .then(res => {
                    this.accountList = res.data;
                    for (var i = 0; i < this.accountList.length; i++) {
                        this.accountList[i].name = this.accountList[i].name + '(' + this.accountList[i].accountTypeName + ')';
                    }
                })
                // 查询方式
                tableRedshiftWarningVue.alarmWay();
                 // 查询报警延时
                tableRedshiftWarningVue.getAlarmDelay();
              //监控时段
              tableRedshiftWarningVue.searchMonitorPeriod();
            },
            // 选择账户
            changeAccount: function () {
                if (this.redshiftWarningForm.account == "" || this.redshiftWarningForm.account == null) {
                    return;
                }
                this.redshiftWarningForm.backupRegion = '';
                // 清空表格
                this.tableRedshiftDate = [];
                this.instanceList = [];
                this.isShowSearch = true;
                this.isNextClick = true;
                tableRedshiftWarningVue.$api.account.queryAccountRegions("accountId", this.redshiftWarningForm.account)
                .then(res => {
                    this.backupRegionList = res.data;
                });
                // 查询通知对象
                tableRedshiftWarningVue.queryContacts();
                // 查询联系人组
                tableRedshiftWarningVue.listContactGroups();
            },
            /***********存储区域**************************/
            selectBackupRegionAll(){
                this.redshiftWarningForm.backupRegion = []
                if (this.singleBackupRegion) {
                    this.backupRegionList.map((item) => {
                        this.redshiftWarningForm.backupRegion.push(item.name)
                    })
                } else {
                    this.redshiftWarningForm.backupRegion = []
                }
            },
            // 切换存储区域
            changebackupRegion: function (val) {
                if (val.length === this.backupRegionList.length&&val.length!=0) {
                    this.singleBackupRegion = true
                } else {
                    this.singleBackupRegion = false
                }
                // 表格数据为空、显示查询按钮、存储区域为空
                this.tableRedshiftDate = [];
                this.instanceList = [];
                this.isShowSearch = true;
                this.isNextClick = true;
            },
            // 全选 单选
            /***********************************************************************************/
            // 单选
            selectChange(selection) {
                // 所有数据
                this.selection = selection;
                // 清空数组
                this.newTableRedshiftDateList = [];
                for (var i = 0; i < this.selection.length; i++) {
                    var TableRedshiftCopy = new Object();
                    TableRedshiftCopy.clusterIdentifier = this.selection[i].clusterIdentifier;
                    TableRedshiftCopy.accountId = this.selection[i].accountId;
                    TableRedshiftCopy.address = this.selection[i].address;
                    TableRedshiftCopy.clusterStatus = this.selection[i].clusterStatus;
                    TableRedshiftCopy.clusterAvailabilityStatus = this.selection[i].clusterAvailabilityStatus;
                    TableRedshiftCopy.status = this.selection[i].status;
                    TableRedshiftCopy.recentEvents = this.selection[i].recentEvents;
                    TableRedshiftCopy.nodes = this.selection[i].nodes;
                    TableRedshiftCopy.zone = this.selection[i].zone;
                    TableRedshiftCopy.clusterParameterGroup = this.selection[i].clusterParameterGroup;
                    TableRedshiftCopy.clusterSubnetGroup = this.selection[i].clusterSubnetGroup;
                    TableRedshiftCopy.releaseStatus = this.selection[i].releaseStatus;
                    TableRedshiftCopy.subnet = this.selection[i].subnet;
                    TableRedshiftCopy.region = this.selection[i].region;
                    this.newTableRedshiftDateList.push(TableRedshiftCopy);
                }
                // 选了数据 可以点击下一步
                if (this.newTableRedshiftDateList.length == 0) {
                    this.isNextClick = true;
                } else {
                    this.isNextClick = false;
                }
            },
            // 全选
            selectAll: function (selection) {
                // 所有数据
                this.selection = selection;
                // 清空数组
                this.newTableRedshiftDateList = [];
                for (var i = 0; i < this.selection.length; i++) {
                    // 状态
                    var TableRedshiftCopy = new Object();
                    TableRedshiftCopy.clusterIdentifier = this.selection[i].clusterIdentifier;
                    TableRedshiftCopy.accountId = this.selection[i].accountId;
                    TableRedshiftCopy.address = this.selection[i].address;
                    TableRedshiftCopy.clusterStatus = this.selection[i].clusterStatus;
                    TableRedshiftCopy.clusterAvailabilityStatus = this.selection[i].clusterAvailabilityStatus;
                    TableRedshiftCopy.status = this.selection[i].status;
                    TableRedshiftCopy.recentEvents = this.selection[i].recentEvents;
                    TableRedshiftCopy.nodes = this.selection[i].nodes;
                    TableRedshiftCopy.zone = this.selection[i].zone;
                    TableRedshiftCopy.clusterParameterGroup = this.selection[i].clusterParameterGroup;
                    TableRedshiftCopy.clusterSubnetGroup = this.selection[i].clusterSubnetGroup;
                    TableRedshiftCopy.releaseStatus = this.selection[i].releaseStatus;
                    TableRedshiftCopy.subnet = this.selection[i].subnet;
                    TableRedshiftCopy.region = this.selection[i].region;
                    this.newTableRedshiftDateList.push(TableRedshiftCopy);
                }
                if (this.selection.length == 0) {
                    this.isNextClick = true;
                } else {
                    this.isNextClick = false;
                }
            },
            // 创建添加或编辑报警
            /**********************************************************************************/
            ok: function (name) {
                this.$refs[name].validate(valid => {
                    if (valid) {
                        var alertList = {
                            "alertRuleName": this.redshiftWarningForm.ruleName,
                            "monitorIndex": this.redshiftWarningForm.monitorIndex,
                            "cycle": this.redshiftWarningForm.cycle,
                            "continousCycle": this.redshiftWarningForm.continousCycle,
                            "statisticsValue": this.redshiftWarningForm.statisticsValue,
                            "relationshipSign": this.redshiftWarningForm.relationshipSign,
                            "accountId": this.redshiftWarningForm.account,
                            "monitorModule": this.monitorModule,
                            "noticeType": this.redshiftWarningForm.noticeType,
                            "unit": this.units,
                            "delay":this.redshiftWarningForm.alarmDelay,
                            "monitorPeriod":this.redshiftWarningForm.monitorPeriod,
                            "thresholdValue":this.redshiftWarningForm.thresholdValue,
                            "contactType":this.redshiftWarningForm.contactType,
                            "enterpriseWechatRobotIds":this.redshiftWarningForm.enterpriseWechatRobotIds
                        };

                        // 如果联系方式是联系人 传通知对象
                        if(this.redshiftWarningForm.contactType == 0){
                            alertList.contactIDs = this.redshiftWarningForm.notificationObject;
                        }
                        // 如果联系方式是联系人组 传联系人组
                        else if(this.redshiftWarningForm.contactType == 1){
                          alertList.contactGroupIds = this.redshiftWarningForm.contactGroupIds;
                        }

                        if (this.redshiftWarningForm.id > 0) {
                            alertList.id = this.redshiftWarningForm.id;
                            alertList.resourceClusterDTOList = this.newTableRedshiftDateList;
                            // 编辑告警
                            this.addloading=true;
                            tableRedshiftWarningVue.$api.alertRule.updateAlertRule(alertList)
                                .then(res => {
                                    this.data = res.data;
                                    setTimeout(() => {
                                        this.reload();
                                        this.redshiftWarningForm.notificationObject = [];
                                        this.$refs[name].resetFields();
                                        this.loading = false;
                                        this.$emit('on-ok', this.form);
                                        this.$nextTick(() => {
                                            this.loading = true;
                                        });
                                        this.$Message.success(this.$t('common.editSuccess'));
                                        // 禁止点击下一步
                                        this.isNextClick = true;
                                        this.isShowSearch = false;
                                        this.isShowEmail = false;
                                        this.isShowWeChat = false;
                                        this.addloading=false;
                                        this.modal = false;
                                        this.wechatWarningVisible=false;
                                        this.isAddOrEdit=true;
                                    }, 1000);
                                })
                        } else {
                            // 添加告警
                            this.addloading=true;
                            alertList.resourceClusterDTOList = this.newTableRedshiftDateList;
                            tableRedshiftWarningVue.$api.alertRule.createAlertRule(alertList)
                                .then(res => {
                                    this.data = res.data;
                                    setTimeout(() => {
                                        this.reload();
                                        tableRedshift.methods.showAll();
                                        this.redshiftWarningForm.notificationObject = [];
                                        this.$refs[name].resetFields();
                                        this.loading = false;
                                        this.$emit('on-ok', this.form);
                                        this.$nextTick(() => {
                                            this.loading = true;
                                        });
                                        this.$Message.success(this.$t('common.addSuccess'));
                                        // 禁止点击下一步
                                        this.isNextClick = true;
                                        this.isShowEmail = false;
                                        this.isShowWeChat = false;
                                        this.addloading=false;
                                        this.modal = false;
                                        this.wechatWarningVisible=false;
                                        this.isAddOrEdit=true;
                                    }, 1000);
                                })
                        }
                    } else {
                        //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
                        this.loading = false;
                        setTimeout(() => {
                            this.loading = true
                        }, 0)
                        if (this.redshiftWarningForm.id > 0) {
                            this.$Message.error(this.$t('common.editFail'));
                        } else {
                            this.$Message.error(this.$t('common.addFail'));
                        }
                    }
                });
            },
            // 取消
            cancel: function (name) {
                this.wechatWarningVisible=false;
                this.isAddOrEdit=true;
                this.isShowSearch = false;
                this.isShowEmail = false;
                this.isShowWeChat = false;
                this.isNextClick = true;
                this.modal = false;
                this.$emit('on-cancel');
                this.redshiftWarningForm.notificationObject = [];
                this.$nextTick(() => {
                    this.$refs[name].resetFields();
                });
                // 清空表格
                this.tableRedshiftDate = [];
            }
        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/monitor/redshift/AddOrUpdateRedshiftWarning.vue